// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-output.js';

import { paths } from '../generated/file-output';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-output', Original, paths);
